import { render, staticRenderFns } from "./CurriculumListEECTable.vue?vue&type=template&id=2710af82&scoped=true&"
import script from "./CurriculumListEECTable.vue?vue&type=script&lang=ts&"
export * from "./CurriculumListEECTable.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumListEECTable.vue?vue&type=style&index=0&id=2710af82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710af82",
  null
  
)

export default component.exports